module.exports = __webpack_public_path__ + "static/media/Sample_Excel_for_Upload.f1541e17.xlsx";